import { extractTextFromQuery } from '../../../utils/query-utils';

export default {
  param: extractTextFromQuery,
  query: function(text) {
    // const words = text.trim().split(' ');

    if (text) {
      return {
        $or: [
          {
            activity: {
              $where: {
                description: {
                  $ilike: `%${text}%`
                }
              }
            },
          },
          {
            description: {
              $ilike: `%${text}%`
            }
          },
          {
            audience: {
              $ilike: `%${text}%`
            }
          },
          {
            objective: {
              $ilike: `%${text}%`
            }
          }
        ]
      }
    }
  }
}
